import buildURL from 'axios/lib/helpers/buildURL'

import BackendService from '@/services/Backend'
import { FILE_UPLOAD_CONTEXT_ADVISORY_PROTOCOL, FILE_UPLOAD_CONTEXT_PRE_INSURER } from '@/config/constants'
import { isRequired, NotFoundError } from '@/utils/CustomErrors'

const $_getBaseUrl = params => {
  const { uploadContext = isRequired('uploadContext') } = params

  if (uploadContext === FILE_UPLOAD_CONTEXT_PRE_INSURER) {
    const {
      basketId = isRequired('basketId'),
      personId = isRequired('personId'),
      fileId = isRequired('fileId'),
      documentType, // optional, used for POST only
    } = params

    return ['baskets', basketId, 'residencepermit', personId, fileId, documentType]
  }

  if (uploadContext === FILE_UPLOAD_CONTEXT_ADVISORY_PROTOCOL) {
    let {
      basketId = isRequired('basketId'),
      documentType, // optional, only used for POST,
      fileId, // optional, used for file GET and DELETE
    } = params


    return ['baskets', basketId, 'advisory-protocol', 'documents', documentType, fileId]
  }

  throw new NotFoundError(`Invalid uploadContext: ${uploadContext}`)
}

// TODO create object to pass these params, don't simply attach all to URL
const createUrl = params => {
  const { jwToken = isRequired('jwToken') } = params

  let uri = $_getBaseUrl(params)

  uri = uri
    .filter(x => !!x) // filter because of optional parameters
    .join('/')
  return buildURL(uri, { jwToken })
}

class File extends BackendService {
  constructor(baseUrl, interceptor) {
    super(baseUrl, '/ovpv3', interceptor)
  }

  /**
   * @param {Object} payload
   * @param {Blob} fileBlob
   * @param {Object} config
   * @returns {AxiosPromise<any>}
   */
  uploadFile(payload, fileBlob, config = {}) {
    const { basketId, documentType, fileId, jwToken, personId, uploadContext } = payload

    const formData = new FormData()
    const name = uploadContext === FILE_UPLOAD_CONTEXT_PRE_INSURER ? 'residencePermitFile' : 'document'
    formData.append(name, fileBlob, fileBlob.name.replace('=', '_'))

    return this.axios.post(createUrl({ jwToken, basketId, personId, fileId, documentType, uploadContext }), formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      ...config,
    })
  }

  /**
   * @param payload
   * @returns {string}
   */
  createFileUrl({ basketId, fileId, jwToken, personId, uploadContext }) {
    return [this.baseUrl, createUrl({ jwToken, basketId, personId, fileId, uploadContext })].join('/')
  }

  /**
   * @param payload
   * @returns {AxiosPromise}
   */
  deleteFile({ basketId, fileId, jwToken, personId, uploadContext }) {
    return this.delete(createUrl({ jwToken, basketId, personId, fileId, uploadContext }), {})
  }
}

export default File
